module.exports = __webpack_public_path__ + "static/media/294557.adfb78f5.png";